import { render, staticRenderFns } from "./codList.vue?vue&type=template&id=0bf3db17&scoped=true"
import script from "./codList.vue?vue&type=script&lang=js"
export * from "./codList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf3db17",
  null
  
)

export default component.exports